import { buildApiUrl } from "../config/api";

// utils/fetchWithAuth.js
export async function fetchWithAuth(path, options = {}) {
  // по умолчанию include credentials (cookie)
  options.credentials = "include";
  options.headers = {
    "Content-Type": "application/json",
    'Auth': localStorage.getItem("authToken"),
    ...(options.headers || {})
  };

  const response = await fetch(buildApiUrl(path), options);

  if (!response.ok) {
    if (response.status === 401) {
      // если 401 — переходим на /admin
      window.location.href = "/admin";
      return; // чтобы дальше код не выполнялся
    }

    // выбрасываем ошибку для остальных статусов
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(errorData.error || "Помилка мережі");
    error.status = response.status;
    throw error;
  }

  return response.json();
}
